import { BasePaginatorDto } from '@diritto/common/base/paginator/paginator.dto';
import {
  RollingRelayResponseDto,
  RollingsRelayByIdsRequestDto,
  RollingsRelayResponseDto,
} from '@diritto/common/relay/dtos/rolling-relay.dtos';
import { Http } from '@diritto/common/utils/requester/http';
import { AxiosRequestConfig } from 'axios';

export class RelayRollingApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async findByRollingId(rollingId: number, includeAdult: boolean, options?: AxiosRequestConfig) {
    const res = await this.http.get<RollingRelayResponseDto>(`${this.url}/relay/rollings`, {
      ...options,
      params: {
        rollingId,
        includeAdult,
      },
    });
    return res.data;
  }

  async findByRollingIds(requestDto: RollingsRelayByIdsRequestDto, options?: AxiosRequestConfig) {
    const res = await this.http.post<RollingsRelayByIdsRequestDto, RollingsRelayResponseDto>(
      `${this.url}/relay/rollings`,
      requestDto,
      {
        ...options,
      },
    );
    return res.data;
  }

  async findRandomByTag(params: { tag?: string; includeAdult: boolean }, paginator?: BasePaginatorDto) {
    const res = await this.http.get<RollingsRelayResponseDto>(`${this.url}/relay/rollings/random-by-tag`, {
      params: {
        ...params,
        ...paginator,
      },
    });
    return res.data;
  }

  async findByProfileId(profileId: number, includeAdult: boolean, paginator?: BasePaginatorDto) {
    const res = await this.http.get<RollingsRelayResponseDto>(`${this.url}/relay/rollings/profiles/${profileId}`, {
      params: {
        includeAdult,
        ...paginator,
      },
    });
    return res.data;
  }

  async findByContentId(contentId: number, includeAdult: boolean, paginator?: BasePaginatorDto) {
    const res = await this.http.get<RollingsRelayResponseDto>(`${this.url}/relay/rollings/contents/${contentId}`, {
      params: {
        includeAdult,
        ...paginator,
      },
    });
    return res.data;
  }
}
